import BracketsPointsLobby from './BracketsPointsLobby';
export default BracketsPointsLobby;
